import { isNil } from 'lodash';
import { DEFAULT_ARROW_PROPS } from '../../../../../Shape/config/Shapes';

const getHeadWidth = shape => (isNil(shape.get('headWidth')) ? DEFAULT_ARROW_PROPS.headWidth : shape.get('headWidth'));

export default getHeadWidth;
